import React, {useState} from 'react';
import {addYears} from "date-fns";
import {toKSTISOString, toKSTISOStringEnd} from "../../../components/commonmethod/CommonMethod";
import {PageHeader} from "../../../components/PageHeader";
import useRequestData from "../../../hooks/useRequestData";
import {DailyCheckReportListType} from "./subPages/DailyCheckReportListType";
import {getDailyCheckReportList} from "../../../api/evaluation/DailyCheckReportService";

function DailyCheckReportList() {
    const [checked,setChecked] = useState([]);
    const initDate ={
        startDate:toKSTISOString(addYears(new Date(),-1)),
        endDate:toKSTISOStringEnd(addYears(new Date(),0)),
    }

    const { newData, pageInfo, dataHook} = useRequestData(getDailyCheckReportList, initDate, "daily_check_report");
    
    return (
        <>
            <div className="common-container container-height-full">
                <PageHeader header={"일일체크현황"} indicator={"평가관리/보고서 > 업무보고서 > 일일체크현황"}/>
                <DailyCheckReportListType data={newData} date={initDate} pageInfo={pageInfo} dataHook={dataHook} checked={{checked: checked, setChecked: setChecked}} />
            </div>
        </>
    );
}

export {DailyCheckReportList};